import { Link } from "react-router-dom";
import config from "@/config";
import { Tag } from "antd";
import React from "react";
import { MdLocationOn, MdWatchLater } from "react-icons/md";
import { BiSolidDollarCircle } from "react-icons/bi";
import { FaUser } from "react-icons/fa";

export const JobListCard = ({ data, index, handleClick }) => {
    const handleLink = () => {
        window.scroll({ top: 0, behavior: 'smooth' });
        handleClick(data.Pk);
    }
    return (
        <div
            onClick={handleLink}
            className=" flex gap-4 p-2 border-2 transition-all hover:border-primary-hover rounded-xl hover:shadow-lg hover:-translate-y-1 cursor-pointer">
            <div className="shrink-0 w-20 h-20 border border-primary p-1 rounded-lg">
                <img className="w-full h-full object-contain"
                    src={`/${data.PhotoCompany}` || config.webConfig.logo} alt="Job Logo" />
            </div>
            <div className="w-full gap-1 flex justify-between flex-col">
                <div className="text-base font-bold line-clamp-1">Trưởng Phòng Kinh Doanh Dược Phẩm</div>
                <div className="flex gap-2 flex-wrap">
                    {/* <div className=" gap-1 items-center text-sm rounded-lg">

                    </div> */}
                    <Tag color={"blue"} className="flex m-0  gap-1 items-center">
                        <MdLocationOn className="w-3 h-3" />
                        <p>Hà nội</p>
                    </Tag>
                    <Tag color={"blue"} className="flex m-0  gap-1 items-center">
                        <BiSolidDollarCircle className="w-3 h-3" />
                        <p>Thỏa thuận</p>
                    </Tag>
                    <Tag color={"blue"} className="flex m-0  gap-1 items-center">
                        <FaUser className="w-3 h-3" />
                        <p>1</p>
                    </Tag>
                </div>
                <div className="flex justify-end">
                    <Tag color={"yellow"} className="flex gap-1 items-center">
                        <MdWatchLater className="w-3 h-3" />
                        <p>01/01/2000</p>
                    </Tag>
                </div>
            </div>
        </div>
    )
}